import React from 'react';
import classNames from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';

import submitArrow from '../../../../assets/newsletter/icon-submit-arrow.svg';

import css from './FooterNewsletter.module.css';

/**
 * The "A Letter Worth Opening" signup band that opens the footer.
 *
 * Console's footer asset supports only markdown blocks, social links, a slogan
 * and a copyright line — there is no form block type — so this lives in code.
 *
 * NOTE: there is no subscribe destination yet (Klaviyo, Mailchimp and a custom
 * route are all still open). Submitting therefore does nothing rather than
 * showing a confirmation the marketplace cannot honour — a false "you're
 * subscribed" is worse than no response. Pass `onSubscribe` once the
 * destination is chosen and the form is live.
 */

/**
 * @component
 * @param {Object} props
 * @param {string?} props.className add style rules in addition to css.root
 * @param {Function?} props.onSubscribe called with the email once a destination exists
 * @returns {JSX.Element}
 */
const FooterNewsletter = props => {
  const { className, onSubscribe } = props;
  const intl = useIntl();

  const handleSubmit = e => {
    e.preventDefault();
    if (typeof onSubscribe === 'function') {
      onSubscribe(new FormData(e.currentTarget).get('email'));
    }
  };

  return (
    <div className={classNames(css.root, className)}>
      <div className={css.copy}>
        <h2 className={css.heading}>
          <FormattedMessage id="FooterNewsletter.heading" />
        </h2>
        <p className={css.subheading}>
          <FormattedMessage id="FooterNewsletter.subheading" />
        </p>
      </div>
      <form className={css.form} onSubmit={handleSubmit}>
        <div className={css.row}>
          {/* Figma shows only the placeholder, but the field still needs a name. */}
          <label className={css.label} htmlFor="footerNewsletterEmail">
            <FormattedMessage id="FooterNewsletter.emailLabel" />
          </label>
          <input
            className={css.input}
            id="footerNewsletterEmail"
            name="email"
            type="email"
            autoComplete="email"
            placeholder={intl.formatMessage({ id: 'FooterNewsletter.emailPlaceholder' })}
          />
          <button
            className={css.submit}
            type="submit"
            aria-label={intl.formatMessage({ id: 'FooterNewsletter.submit' })}
          >
            <img src={submitArrow} alt="" width="24" height="24" />
          </button>
        </div>
        <div className={css.rule} />
      </form>
    </div>
  );
};

export default FooterNewsletter;
